import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sourcingCredits: 0,
  wishlistTriggers: null,
  products: [],
  productsLoading: true,
};

export const sourcingWishlistSlice = createSlice({
  name: "Wishlist",
  initialState: initialState,
  reducers: {
    updateSourcingWishlistTriggers(state, action) {
      state.wishlistTriggers = action.payload;
    },
    updateSourcingWishlistProductsLoading(state, action) {
      state.productsLoading = action.payload;
    },
    updateSourcingCreatorDetails(state, action) {
      state.collectionDetails = action.payload;
    },
    updateSourcingCreatorWishlistProducts(state, action) {
      state.products = action.payload;
    },
    updateSourcingCreatorWishlistLoading(state, action) {
      state.collectionLoading = action.payload;
    },
  },
});

export const {
  updateSourcingWishlistTriggers,
  updateSourcingCreatorDetails,
  updateSourcingCreatorWishlistProducts,
  updateSourcingCreatorWishlistLoading,
  updateSourcingWishlistProductsLoading,
} = sourcingWishlistSlice.actions;
